<template>
  <div>
    <ba-header activeModule="Charts and Graphs"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt3 u-pt5">Charts and Graphs</h2>
      <div class="container">
        <ChartsComponent></ChartsComponent>
      </div>
    </div>
  </div>
</template>

<script>
  import ChartsComponent from '@/modules/charts/charts.component.vue'
  import config from '@/config'

  export default {
    components: {
      ChartsComponent
    },
    methods: {
      getCompanyId () {
        return this.$route.params.companyId
      },
      getURL (chartType) {
        return `${config.url}/company/${this.getCompanyId()}/chart/${chartType}/`
      },
      eDeliveryEnabled () {
        let isEdeliveryEnabled = this.$store.getters['shared/isEdeliveryEnabledInCompany']
        return isEdeliveryEnabled(this.getCompanyId())
      },
      detailsAvailable () {
        return false
      }
    }
  }
</script>
